import "react-phone-input-material-ui/lib/style.css";
import { TextField } from "@mui/material";
import ReactPhoneInput from "react-phone-input-material-ui";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// const StyledInput = styled(TextField)(() => ({
//   "& .MuiInputBase-input.MuiOutlinedInput-input": {
//     height: "3.2em",
//   },
//   "& .MuiInputBase-input.MuiInput-input": {
//     height: "2.05em",
//   },
// }));

function StyledPhoneInput({ value, variant, error, disabled, onChange, onBlur }) {
  return (
    <TextField
      required
      error={error}
      disabled={disabled}
      name="tel"
      label="Tél"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      fullWidth
      variant={variant}
    />
  );
}

export default function PhoneInput({ value, variant, error, disabled, onChange, onBlur }) {
  const [dialCode, setDialCode] = useState("");

  useEffect(() => {
    setDialCode(value ? value.split(" ")[0] : "");
  }, [value]);
  return (
    <ReactPhoneInput
      disabled={disabled}
      value={dialCode}
      onChange={(_, d) => {
        const splitNumber = value.split(" ");
        const f = `+${d.dialCode}${splitNumber.length > 1 ? "" : " "}`;
        setDialCode(f);
        onChange({
          target: {
            name: "tel",
            value: [f].concat(splitNumber.slice(1)).join(" "),
          },
          preventDefault() {},
        });
      }}
      inputProps={{ value, variant, error, disabled, onChange, onBlur }}
      component={StyledPhoneInput}
    />
  );
}

StyledPhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

PhoneInput.defaultProps = {
  variant: "outlined",
};

PhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  variant: PropTypes.string,
  error: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
